import { normalizeDecimal } from 'utils/numberUtils/decimalInput'
import { parseDecimalInput } from 'utils/stringUtils'
import type { DayAheadBidValueFault, DayAheadBidValueReading } from './bidValue.helper.types'

export const DAY_AHEAD_BID_VALUE_DECIMALS = 1

const BID_NUMBER_PATTERN = /^-?\d+(\.\d+)?$/
const BID_VALUE_PATTERN = new RegExp(`^-?\\d+(\\.\\d{1,${DAY_AHEAD_BID_VALUE_DECIMALS}})?$`)

export function normalizeDayAheadBidValue(rawValue: string): string {
  return normalizeDecimal(rawValue)
}

export function isSameDayAheadBidValue(left: string | undefined, right: string | undefined): boolean {
  return normalizeDayAheadBidValue(left ?? '') === normalizeDayAheadBidValue(right ?? '')
}

export function findDayAheadBidValueFault(normalizedValue: string): DayAheadBidValueFault | undefined {
  if (normalizedValue === '') {
    return undefined
  }
  if (BID_VALUE_PATTERN.test(normalizedValue)) {
    return Number.isFinite(Number(normalizedValue)) ? undefined : 'not-a-number'
  }

  return BID_NUMBER_PATTERN.test(normalizedValue) ? 'too-many-decimals' : 'not-a-number'
}

export function readDayAheadBidValue(rawValue: string | undefined): DayAheadBidValueReading {
  const raw = rawValue?.trim() ?? ''
  if (raw === '') {
    return { kind: 'blank' }
  }

  const normalized = normalizeDayAheadBidValue(raw)
  const fault = findDayAheadBidValueFault(normalized)
  return fault === undefined ? { kind: 'value', value: parseDecimalInput(normalized) } : { kind: 'fault', fault }
}

export function roundToDayAheadBidValueDecimals(value: number): number {
  return parseFloat(value.toFixed(DAY_AHEAD_BID_VALUE_DECIMALS))
}
